import * as Types from './mutation-types'
import {
  getModulesQuery
} from './queries.graphql'
import gqlClient from '@/modules/graphql'
import api from "@/modules/api";


const actions = {

  async getModules({
    commit
  }, variables = {}) {
    try {
      commit(Types.GET_MODULES_REQUEST)
      const {
        data: {
          data: {
            system: {
              modules
            }
          }
        }
      } = await gqlClient.query({
        query     : getModulesQuery,
        variables : variables
      })
      commit(Types.GET_MODULES_SUCCESS, modules)
    } catch (e) {
      commit(Types.GET_MODULES_ERROR, e)
    }

  },
  async updateModules({
    commit
  }, variables = {}) {
    try {

      commit(Types.UPDATE_MODULES_REQUEST)
      const {
        data
      } = await api.module.updateModule(variables)
      commit(Types.UPDATE_MODULES_SUCCESS, data)
    } catch (e) {
      commit(Types.UPDATE_MODULES_ERROR, e)
    }

  }

}

export default actions
